<template>
	<div>
		<!-- TODO: add priority state class below based on today/tomorrow date  -->
		<div class="parent-div" @click="onClickTask" :class="{selectedTask:taskSelectFlag == true, alertTask: alertFlag == true}">
			<!-- <div :class="{'img-div':taskSelectFlag == false, 'img-div-checked': taskSelectFlag == true && this.status == 'Complete'}">
				<span v-if="!taskSelectFlag" width="32px" height="32px"></span>
				<img v-if="taskSelectFlag" src="../assets/done.png" width="45px" height="45px" class="align-img" />
			</div> -->

			<div  class="d-flex ml-3 ft-14 pt-3 pL-10" style="padding-left: 10px; padding-top: 15px;">
				{{ name }}

			</div>
			<div class="display-section ft-14 pt-3 pl-20">
				{{referenceNumber}}
q
			</div>

			<div class="pt-2 pl-20" style="padding-top: 10px; padding-bottom: 10px;">
				<SAvatar v-if="!taskSelectFlag" :fullname="assignee" :size="35" :color="'#d8d8d8'" />
			</div>

			<div class="pt-3">
				<div v-if="!taskSelectFlag" :style="setDateDesign">{{date}}</div>
				<div>
					<small v-if="overdueFlag&&!taskSelectFlag" :style="setDateDesign">({{differenceOverdue}} days)</small>
				<small v-if="todayTomorrowFlag&&!taskSelectFlag" :style="setDateDesign">({{todayTomorrowDate}})</small>
				</div>

			</div>

			<div class="display-section">
				<p class="grey-text">Task <span v-if="!completeFlag"> Created </span><span v-if="completeFlag"> Completed</span></p>
				<small class="grey-text">{{createdDate}}</small>
			</div>
		</div>
	</div>
</template>

<script>
import SAvatar from "./SAvatar";
import moment from "moment";

export default {
	name: 'STask',

	components: {
		SAvatar
	},

	data(){
		return{
			taskSelectFlag: false,
			alertFlag: false,
			date: null,
			differenceOverdue: null,
			overdueFlag: false,
			todayTomorrowFlag: false,
			todayTomorrowDate: null,
			completeFlag: false
		}
	},

	props: {
		shipmentNumber: {type: String},
		referenceNumber:{type:String},
		assignee: {type: String},
		dueDate: {type:String},
		taskType: {type:Array},
		status: {type:String},
		name: {type: String},
		createdDate: {type: String}
	},

	methods: {
		onClickTask(){
			if(this.status == 'Complete'){
				this.taskSelectFlag = !this.taskSelectFlag;
			}

			if(this.status == 'Todo' || this.status == 'Progress'){
				// open dialog here
			}
		},
		checkDate(){
			let today = moment().format('YYYY-MM-DD');
			let taskDate = moment(this.dueDate).format('YYYY-MM-DD');
			this.differenceOverdue = moment(taskDate).diff(today, 'days');
			if(this.differenceOverdue<0){
				let num = this.differenceOverdue.toString().split('-');
				this.differenceOverdue = num[1];
			}
			else{
				this.differenceOverdue = '';
			}

			if(this.dueDate){
				if(moment(today).isSame(taskDate)){
					this.date = 'Due Today';
					this.todayTomorrowDate = moment().format('DD MMM YY');
					this.todayTomorrowFlag = true;
					this.alertFlag = true;
				}
				else if(moment(today).isBefore(taskDate) && moment(taskDate).diff(today, 'days')==1){
					this.date = 'Due Tomorrow';
					this.todayTomorrowDate = moment().add(1,'days').format('DD MMM YY');
					this.todayTomorrowFlag = true;
					this.alertFlag = true;
				}
				else if(moment(today).isAfter(taskDate)){
						this.date = 'Overdue';
						this.alertFlag = true;
						this.overdueFlag = true;
				}
				else{
					this.date = moment(this.dueDate).format('DD MMM YY') ;
					this.alertFlag = false;
				}
			}
		},
		checkStatus(){
			if(this.status == 'Complete'){
				this.completeFlag = true;
				this.taskSelectFlag = true;
			}
			else{
				this.completeFlag = false;
				this.taskSelectFlag = false;
			}
		}
	},

	computed: {
		setDateDesign(){
			if(this.alertFlag){
				return {
					'color': '#ff0000', //red color
					'font-size': '12px',
					'font-family': 'Roboto',
					'margin-left': '30px',
					'margin-bottom': '-3px',
					'margin-top': '12px'
				}
			}
			else{
				return {
					'color': '#979797', //grey color
					'font-size': '12px',
					'font-family': 'Roboto',
					'margin-left': '30px',
				}
			}
		}
	},

	mounted(){
		this.checkDate();
		this.checkStatus();
	}
}
</script>

<style scoped>
.display-section {
	display: flex;
	justify-content :center;
	align-items: center;
}
.grey-text{
	color: #979797;
	font-size: 12px;
	  font-family: "Roboto !important";
	margin-left: 30px;
	margin-bottom: -3px;
	margin-top: 12px;
}
.parent-div{
	/* border-left: 8px solid var(--white); */
	/* border-top: solid 1px var(--white); */
	border-bottom: solid 1px var(--white);
	cursor: pointer;
	display: grid;
	grid-template-columns: 1.5fr 5fr 1fr 2fr 2fr;
	/* height: 65px;
 	align-content: center; */
}
.img-div{
	border: 1px solid var(--very-light-pink);
	border-radius: 50%;
	height: 32px;
	width: 32px;
	margin-left: 32px;
	margin-top: 4px;

}
.img-div-checked{
	/* height: 32px; */
	width: 32px;

}
.alertTask{
		/* border-left: 8px solid var(--primary); */
}
.align-img{
	margin-left: 28px;
}
.shipment-number{
	font-size: 14px;
	  font-family: "Roboto !important";
	color: #21a1d8;
}
.text{
	font-size: 14px;
	font-family: 'Roboto';
	font-weight: 100;
	color: black;
	display: contents;
}
.selectedTask{
	background-color: var(--white);
	border-left: 8px solid #a7e06b;
}
.priority-state{
	background-color: var(--primary);
	border-left: 8px solid #a7e06b;
}
.ft-14{
	font-size: 14px;
	font-weight: 500;
}
@media(min-width:300px) and (max-width:1100px){
	.parent-div{
	border-top: solid 1px var(--white);
	border-bottom: solid 1px var(--white);
	cursor: pointer;
	display: block;
  }
  .display-section {
	display: flex;
	justify-content: left;
	align-items: left;
  }
  .pl-20{
	padding-left:20px
  }
  .pL-10 {
	padding-left: 10px;
  }
}
</style>